var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataNull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 54,
    viewBox: "0 0 40 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5625 0.750977C1.76757 0.750977 0.3125 2.20606 0.3125 4.00098V50.0004C0.3125 51.7953 1.76757 53.2504 3.5625 53.2504H36.4371C38.232 53.2504 39.6871 51.7953 39.6871 50.0004V16.0629L24.3752 0.750977H3.5625Z",
    fill: "#DBDCDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6875 15.75V0.75L39.6875 15.75H24.6875Z",
    fill: "#989BA2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 26L29.6865 44.749",
    stroke: "white",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6875 26L10.9385 44.749",
    stroke: "white",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataNull);
export default __webpack_public_path__ + "static/media/data-null.8b6759496d6a4dfb0e4ae049f23ef663.svg";
export { ForwardRef as ReactComponent };